/**
 * Validazione Codice Fiscale italiano (16 caratteri, checksum + struttura incluso omocodia).
 * Logica tabulare allineata a specifiche comuni (posizioni dispari/pari, lettera di controllo).
 */
(function () {
  if (window.__codiceFiscaleCartInit) return;
  window.__codiceFiscaleCartInit = true;

  function debounce(fn, wait) {
    let t;
    return function (...args) {
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, wait);
    };
  }

  const CHECK_CODE_ODD = {
    0: 1,
    1: 0,
    2: 5,
    3: 7,
    4: 9,
    5: 13,
    6: 15,
    7: 17,
    8: 19,
    9: 21,
    A: 1,
    B: 0,
    C: 5,
    D: 7,
    E: 9,
    F: 13,
    G: 15,
    H: 17,
    I: 19,
    J: 21,
    K: 2,
    L: 4,
    M: 18,
    N: 20,
    O: 11,
    P: 3,
    Q: 6,
    R: 8,
    S: 12,
    T: 14,
    U: 16,
    V: 10,
    W: 22,
    X: 25,
    Y: 24,
    Z: 23,
  };

  const CHECK_CODE_EVEN = {
    0: 0,
    1: 1,
    2: 2,
    3: 3,
    4: 4,
    5: 5,
    6: 6,
    7: 7,
    8: 8,
    9: 9,
    A: 0,
    B: 1,
    C: 2,
    D: 3,
    E: 4,
    F: 5,
    G: 6,
    H: 7,
    I: 8,
    J: 9,
    K: 10,
    L: 11,
    M: 12,
    N: 13,
    O: 14,
    P: 15,
    Q: 16,
    R: 17,
    S: 18,
    T: 19,
    U: 20,
    V: 21,
    W: 22,
    X: 23,
    Y: 24,
    Z: 25,
  };

  const CHECK_CODE_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const CF_REGEX =
    /^[A-Z]{6}[0-9LMNPQRSTUV]{2}[ABCDEHLMPRST]{1}[0-9LMNPQRSTUV]{2}[A-Z]{1}[0-9LMNPQRSTUV]{3}[A-Z]{1}$/;

  function getCheckCode(fifteen) {
    let val = 0;
    for (let i = 0; i < 15; i++) {
      const c = fifteen[i];
      val += i % 2 !== 0 ? CHECK_CODE_EVEN[c] : CHECK_CODE_ODD[c];
    }
    return CHECK_CODE_CHARS.charAt(val % 26);
  }

  function normalizeCf(raw) {
    return String(raw || '')
      .toUpperCase()
      .replace(/\s+/g, '');
  }

  function isValidItalianCodiceFiscale(value) {
    const cf = normalizeCf(value);
    if (cf.length !== 16 || !CF_REGEX.test(cf)) return false;
    return getCheckCode(cf.slice(0, 15)) === cf[15];
  }

  function getMessages(container) {
    return {
      required: container.getAttribute('data-msg-required') || '',
      invalid: container.getAttribute('data-msg-invalid') || '',
    };
  }

  function setError(container, message) {
    const wrap = container.querySelector('[data-cf-field-wrap]');
    const errEl = container.querySelector('[data-cf-error]');
    const input = container.querySelector('[data-codice-fiscale-input]');
    if (!errEl || !input) return;
    const hasErr = Boolean(message);
    errEl.textContent = message || '';
    errEl.hidden = !hasErr;
    input.setAttribute('aria-invalid', hasErr ? 'true' : 'false');
    if (wrap) wrap.classList.toggle('field--has-error', hasErr);
  }

  function findBlock(el) {
    return el && el.closest && el.closest('[data-codice-fiscale-block]');
  }

  /** Salva l'attributo sul carrello quando il CF è valido (persistenza dopo aggiornamenti riga). */
  const debouncedSave = debounce(function (validCf) {
    if (!validCf || !window.routes || !window.routes.cart_update_url) return;
    const body = JSON.stringify({
      attributes: { codice_fiscale: validCf },
    });
    fetch(`${window.routes.cart_update_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body,
    }).catch(function () {});
  }, 400);

  function onInput(event) {
    const input = event.target;
    if (!input.matches || !input.matches('[data-codice-fiscale-input]')) return;
    const block = findBlock(input);
    if (!block) return;
    let v = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (v.length > 16) v = v.slice(0, 16);
    if (v !== input.value) input.value = v;
    setError(block, '');
    if (v.length === 16 && isValidItalianCodiceFiscale(v)) debouncedSave(v);
  }

  function onBlur(event) {
    const input = event.target;
    if (!input.matches || !input.matches('[data-codice-fiscale-input]')) return;
    const block = findBlock(input);
    if (!block) return;
    const raw = input.value;
    if (!normalizeCf(raw)) return;
    const msgs = getMessages(block);
    if (!isValidItalianCodiceFiscale(raw)) setError(block, msgs.invalid);
  }

  /**
   * Ritorna true se il checkout può proseguire.
   * Nota: se event.submitter è null (Invio nel form, alcuni Safari), prima si saltava tutta la validazione — ora si considera sempre come tentativo checkout, perché nei nostri form c’è un solo pulsante submit.
   */
  function enforceCfBeforeCheckout(form) {
    const block = form.querySelector('[data-codice-fiscale-block]');
    if (!block) return true;

    const input = block.querySelector('[data-codice-fiscale-input]');
    if (!input) return true;

    const msgs = getMessages(block);
    const raw = input.value;
    const n = normalizeCf(raw);

    if (!n) {
      setError(block, msgs.required);
      input.focus();
      return false;
    }

    if (!isValidItalianCodiceFiscale(raw)) {
      setError(block, msgs.invalid);
      input.focus();
      return false;
    }

    input.value = n;
    return true;
  }

  function isCheckoutSubmission(form, submitEvent) {
    const submitter = submitEvent.submitter;
    if (!submitter) return true;
    return submitter.getAttribute('name') === 'checkout';
  }

  function onSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('#cart, #CartDrawer-FormSummary')) return;
    if (!isCheckoutSubmission(form, event)) return;

    if (!enforceCfBeforeCheckout(form)) {
      event.preventDefault();
      event.stopPropagation();
    }
  }

  /** Backup: preventDefault sul click blocca anche submit senza SubmitEvent.submitter affidabile */
  function onCheckoutButtonClickCapture(event) {
    const button =
      event.target &&
      event.target.closest &&
      event.target.closest('button[type="submit"][name="checkout"]');
    if (!button) return;
    const form = button.form;
    if (!form || !form.matches('#cart, #CartDrawer-FormSummary')) return;
    if (!enforceCfBeforeCheckout(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }

  document.addEventListener('input', onInput);
  document.addEventListener('blur', onBlur, true);
  document.addEventListener('submit', onSubmit, true);
  document.addEventListener('click', onCheckoutButtonClickCapture, true);

  window.validateItalianCodiceFiscale = isValidItalianCodiceFiscale;
})();

